import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { DetalhesDiarioOficial } from "./detalhes-diario-oficial"
import { DetalhesDiarioOficialProvider } from "./context/detalhes-diario-oficial-context"


export const DetalhesDiarioOficialFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle="Detalhes Diário Oficial">
            <DetalhesDiarioOficialProvider>
                <DetalhesDiarioOficial></DetalhesDiarioOficial>
            </DetalhesDiarioOficialProvider>
        </BaseInternalFormFactory>
    )
}